import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import List from "../views/List.vue";
import Detail from "../views/Detail.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/List",
    name: "List",
    component: List,
  },
  {
    path: "/Detail",
    name: "Detail",
    component: Detail,
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
